import React from 'react'

const ImageComponent = React.forwardRef((props, ref) => <img ref={ref} {...props} />)

export default ImageComponent

ImageComponent.defaultProps = {
    draggable: false
}